import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ACConfigHeader from '../components/ACConfigHeader'
import UploadExternalEvaluation from './UploadExternalEvaluation'
import UploadMatchingCsv from './UploadMatchingCsv'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  addBulkNonCustomMatchingEval,
  addCustomMatchingEval,
  confirmUploadMatching,
  createAppraisal,
  deleteAppraisal,
  getAppraisal,
  getAppraisalEvals,
} from 'services/api/modules/performance/appraisal/appraisal'
import AdxInput from 'components/custom/AdxInput'
import { useNavigate } from 'react-router-dom'
import ACCDatePicker from '../components/ACCDatePicker/ACCDatePicker'
import { format } from 'date-fns'
import ACNonCustomEvaluationList from '../components/ACNonCustomEvaluationList'
import AddIcon from '@mui/icons-material/Add'
import AdxInfoIcon from 'components/custom/AdxInfoIcon'
import ACPopper from '../components/ACPopper'
import ACNonCustomEvaluation from '../components/ACNonCustomEvaluation'
import {
  deleteEvaluation,
  getAllEvaluation,
  saveEvaluation,
} from 'services/api/modules/performance/appraisal/evaluation'
import ACCustomEvaluation from '../components/ACCustomEvaluation'
import ACCustomEvaluationList from '../components/ACCustomEvaluationList'
import ACMatchingTable from '../components/ACMatchingTable'
import ACExternalEvalTable from '../components/ACExternalEvalTable'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import EvaluationSnackBar from '../../appraisal-company-mgmt/components/EvaluationSnackBar'
import AdxButton from 'components/custom/AdxButton'

const AppraisalCycleConfig = () => {
  const navigate = useNavigate()
  const [appraisalTitle, setAppraisalTitle] = useState('')
  const [appraisalDescription, setAppraisalDescription] = useState('')
  const [date, setDate] = useState({ startDate: '', endDate: '' })
  const [evalPage, setEvalPage] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false)
  const [externalUpload, setExternalUpload] = useState(false)
  const [matchingUpload, setMatchingUpload] = useState(false)
  const [matchingCSVUpload, setMatchingCSVUpload] = useState(false)
  const [appraisalStatus, setAppraisalStatus] = useState(false)
  const [getError, setGetError] = useState()
  const [showError, setShowError] = useState(false)
  const [specialError, setSpecialError] = useState('')

  // Non Custom Mathcing
  const [nonCustomValue, setNonCustomValue] = useState([])
  const [nonCustomEval, setNonCustomEval] = useState([])
  const [nonCustomDisabled, setNonCustomDisabled] = useState([])

  //  Custom Matching
  const [customValue, setCustomValue] = useState([])
  const [customEval, setCustomEval] = useState([])
  const [customDisabled, setCustomDisabled] = useState([])
  const [customMatchingId, setCustomMatchingId] = useState('')
  const [getMatchingData, setGetMatchingData] = useState('')
  const [showMatchingTable, setShowMatchingTable] = useState(false)
  const [completeUploadMatching, setCompleteUploadMatching] = useState(false)
  const [staffData, setStaffData] = useState([])
  const [upload, setUpload] = useState(false)
  const [matchingLoading, setMatchingLoading] = useState(true)

  // External Evaluation
  const [getExternalData, setGetExternalData] = useState([])
  const [completeUploadExternal, setCompleteUploadExternal] = useState(false)
  const [externalCSVUpload, setExternalCSVUpload] = useState(false)
  const [externalLoading, setExternalLoading] = useState(true)

  // API integration
  const queryClient = useQueryClient()

  const {
    error: createError,
    mutate: createMutate,
    data: appraisalData,
  } = useMutation((values) => createAppraisal(values), {
    onSuccess: async () => {
      setEvalPage(true)
      setAppraisalStatus(true)
    },
    onError: (error) => {
      setSpecialError(error.data.message)
      if (Object.keys(error?.data?.errors).length > 1) {
        setGetError(Object.values('You have incomplete fields'))
      } else {
        setGetError('You have an incomplete field')
      }
      setShowError(true)
    },
  })
  const { mutate: deleteMutate } = useMutation((values) => deleteAppraisal(values), {
    onSuccess: async () => {
      setEvalPage(false)
      setSpecialError('')
    },
  })

  // Create a duplicate eval to upload matching
  const { mutate: addMatchingEval } = useMutation(addCustomMatchingEval, {
    onSuccess: async (response) => {
      setCustomMatchingId(response?.data?.id)
      handleClose()
      setUpload(false)
      // handleAddCustomEval(response?.data)
      setMatchingCSVUpload(true)
      refetchAppraisalData()
      return response?.data
    },
  })

  const { mutate: mutateConfirmUploadMatching } = useMutation(confirmUploadMatching, {
    onSuccess: () => {
      setUpload(false)
      setCompleteUploadMatching(false)
      setMatchingCSVUpload(false)
      refetchAppraisalData()
    },
  })

  const { mutate: deleteMatchingEvaluation } = useMutation(deleteEvaluation, {
    onSuccess: async () => {
      refetchAppraisalData()
    },
  })

  const { mutate: addNonCustomBulk } = useMutation(addBulkNonCustomMatchingEval, {
    onSuccess: async () => {
      refetchAppraisalData()
    },
  })

  const { mutate: updateMutate } = useMutation(saveEvaluation, {
    onSuccess: (response) => {
      refetchAppraisalData()
    },
  })

  const { data: getAppraisals } = useQuery(
    ['refetchAppraisalEval', appraisalData?.data?.id],
    async () => {
      const { data } = await getAppraisal(appraisalData?.data?.id)
      return data
    },
    {
      enabled: appraisalStatus,
    }
  )

  const { data: allEvalData } = useQuery('allEvalData', async () => {
    const { data } = await getAllEvaluation()
    return data
  })
  const { data: getAppraisalEvaluations } = useQuery(
    ['appraisalEvalData', appraisalData?.data?.id],
    async () => {
      const { data } = await getAppraisalEvals(appraisalData?.data?.id)
      return data
    }
  )

  const cycleDate = (start, end) => {
    setDate({ startDate: start, endDate: end })
  }

  const handleCreateAppraisal = () => {
    let newAppraisal = {
      label: appraisalTitle,
      description: appraisalDescription,
      start_date: format(date.startDate, `yyyy/MM/dd`),
      due_date: format(date.endDate, `yyyy/MM/dd`),
    }

    createMutate(newAppraisal)
  }

  const handleOpen = () => {
    setModalOpen(true)
    if (externalUpload || matchingUpload) {
      setExternalUpload(false)
      setMatchingUpload(false)
    }
  }

  const handleClose = () => {
    setModalOpen(false)
    setExternalUpload(false)
    setMatchingUpload(false)

    const nonCustomList = []

    getAppraisalEvaluations?.map((item) => {
      if (item?.matching_id !== 4) nonCustomList.push(item)
    })

    setNonCustomEval(nonCustomList)

    const newCustomDisabled = getAppraisalEvaluations?.map((item) => item)

    setNonCustomDisabled(newCustomDisabled)
    setNonCustomValue([])
  }

  const handleAddExternal = () => {
    setExternalUpload(!externalUpload)
  }

  const handleUploadMatching = () => {
    setMatchingUpload(!matchingUpload)
  }

  const handleReturn = () => {
    deleteMutate(appraisalData?.data?.id)
  }

  const handleFinishAppraisal = () => {
    navigate('/app/appraisal-cycle')
  }
  // Non Matching
  const handleNonCustomEval = (event) => {
    let evaluations = nonCustomValue

    const {
      target: { value, checked },
    } = event

    checked ? evaluations.push(+value) : evaluations.splice(evaluations.indexOf(+value), 1)

    setNonCustomValue(evaluations)
    setNonCustomDisabled((nonCustomDisabled) => [...nonCustomDisabled, +value])
  }

  const handleAddNonCustomEval = () => {
    addNonCustomBulk({ appraisalId: appraisalData?.data?.id, data: nonCustomValue })
    // addNonCustomBulk({ appraisalId: 1, data: nonCustomValue })
    setNonCustomValue([])
  }

  const handleRemoveNonCustom = (id) => {
    for (let i = 0; i <= nonCustomEval.length; i++) {
      if (nonCustomEval[i]?.id === id) {
        nonCustomEval.splice(i, 1)
        break
      }
    }

    const newNonCustomDisabled = nonCustomDisabled.filter((item) => {
      return item.id !== id
    })

    deleteMatchingEvaluation(id)
    setNonCustomEval(nonCustomEval)
    setNonCustomDisabled(newNonCustomDisabled)
  }

  // Matching
  const handleCustomEval = (event) => {
    let evaluations = customValue

    const {
      target: { value, checked },
    } = event

    checked ? evaluations.push(+value) : evaluations.splice(evaluations.indexOf(+value), 1)

    let createMatchingEval = {
      evaluation_id: +value,
      appraisal_id: appraisalData?.data?.id,
      // appraisal_id: 1,
    }
    addMatchingEval(createMatchingEval)
    setCustomValue(evaluations)
    setCustomDisabled((customDisabled) => [...customDisabled, +value])
  }

  // const handleAddCustomEval = (item) => {
  //   allEvalData.map((evalData) => {
  //     if (evalData.title === item.title) setCustomEval((customEval) => [...customEval, evalData])
  //   })

  //   setCustomValue([])
  // }

  const handleRemoveCustom = (title, id) => {
    for (let i = 0; i <= customEval.length; i++) {
      if (customEval[i]?.title === title) {
        customEval.splice(i, 1)
        break
      }
    }

    const newCustomDisabled = customDisabled.filter((item) => {
      return item.id !== id
    })

    deleteMatchingEvaluation(id)
    setCustomEval(customEval)
    setCustomDisabled(newCustomDisabled)
  }

  const handleCloseMatchingCSV = () => {
    deleteMatchingEvaluation(customMatchingId)
    setCompleteUploadMatching(false)
    setMatchingCSVUpload(false)
    setUpload(false)
  }

  const refetchAppraisalData = () => {
    queryClient.invalidateQueries('appraisalEvalData')
  }

  useEffect(() => {
    const nonCustomList = []
    const customList = []
    getAppraisalEvaluations?.map((item) => {
      item?.matching_id !== 4 ? nonCustomList.push(item) : customList.push(item)
    })

    setNonCustomEval(nonCustomList)
    setCustomEval(customList)

    const newCustomDisabled = getAppraisalEvaluations?.filter((item) => {
      return item
    })

    setCustomDisabled(newCustomDisabled)
    setNonCustomDisabled(newCustomDisabled)
  }, [getAppraisalEvaluations])

  return (
    <>
      <EvaluationSnackBar
        message={getError}
        status={'error'}
        autoHideDuration={4000}
        showError={showError}
        setShowError={setShowError}
      />
      {/* Modal to create appraisal */}
      <Box
        sx={{
          backgroundColor: 'gray-background.main',
          minHeight: '100vh',
          maxWidth: '100vw',
          gap: 2,
          pb: 2,
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        {/* Header */}
        <ACConfigHeader deleteMutate={deleteMutate} id={appraisalData?.data?.id} />
        {/* Body */}
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          sx={{
            backgroundColor: 'white.main',
            width: { xs: '90%', md: '67%' },
            borderRadius: '4.5px',
            boxShadow: '0px 0px 10px lightgray',
            p: 3,
          }}
        >
          {/* Create Appraisal */}
          {!evalPage && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant={'h4'} fontWeight="bold" color="alternate.main">
                  Step 1 of 2
                </Typography>
                <Typography variant={'h3'} fontWeight="bold">
                  Fill in cycle details
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column" gap={2}>
                <AdxInput
                  label="Title"
                  size="standard"
                  placeholder="E.g January 2021"
                  charLimit={50}
                  value={appraisalTitle}
                  onChange={(i) => {
                    setAppraisalTitle(i.target.value)
                  }}
                  isErrorShown={createError?.data?.errors?.label}
                  errorMessage={<AdxErrorMessage children={createError?.data?.errors?.label} />}
                />
                <AdxInput
                  label="Description (optional)"
                  type="large"
                  placeholder="Type here"
                  charLimit={500}
                  multiline
                  sxInput={{
                    padding: 2,
                    height: '275px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    overflowY: 'auto',
                  }}
                  value={appraisalDescription}
                  onChange={(i) => setAppraisalDescription(i.target.value)}
                />
                <ACCDatePicker
                  label="Period"
                  cycleDate={cycleDate}
                  isErrorShown={specialError || createError?.data?.errors?.due_date}
                  errorMessage={
                    createError?.data?.errors?.due_date ? (
                      <AdxErrorMessage children={createError?.data?.errors?.due_date} />
                    ) : (
                      <AdxErrorMessage children={specialError} />
                    )
                  }
                />
              </Box>
            </Box>
          )}

          {/* Add Evaluation*/}
          {evalPage && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box>
                <Typography variant={'h4'} fontWeight="bold" color="alternate.main">
                  Step 2 of 2
                </Typography>
                <Typography variant={'h3'} fontWeight="bold">
                  Manage evaluation(s)
                </Typography>
              </Box>
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    p: 2,
                    gap: 2,
                    borderBottom: '1px solid',
                    borderBottomColor: 'gray-line.main',
                    backgroundColor: 'gray-background.main',
                  }}
                >
                  <Typography variant="subtitle1" color="light-gray-text.main" width="52%">
                    Evaluation Name
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="light-gray-text.main"
                    sx={{ display: 'flex', justifyContent: 'center', width: '20%' }}
                  >
                    Preview Evaluation
                  </Typography>
                  <Box sx={{ width: '20%', display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Typography
                      variant="subtitle1"
                      color="light-gray-text.main"
                      sx={{ display: 'flex', justifyContent: 'center' }}
                    >
                      Weightage
                    </Typography>
                    <AdxInfoIcon toolTipTitle="Weightage calculated in value, not %" />
                  </Box>
                  <Box width="8%" />
                </Box>
                {nonCustomEval?.map((list) => (
                  <ACNonCustomEvaluationList
                    key={list.id}
                    id={list.id}
                    title={list.title}
                    type={list.type}
                    formId={list.form_id}
                    external={list.is_external === 1 ? true : false}
                    handleRemoveNonCustom={handleRemoveNonCustom}
                    updateMutate={updateMutate}
                  />
                ))}
                {customEval?.map((list) => (
                  <ACCustomEvaluationList
                    key={list.id}
                    id={list.id}
                    title={list.title}
                    type={list.type}
                    formId={list.form_id}
                    weightage={list.weightage}
                    handleRemoveCustom={handleRemoveCustom}
                    updateMutate={updateMutate}
                  />
                ))}
              </Box>
              <ACPopper
                placement="bottom-start"
                placeholder="Add evaluation"
                placeholderColor="alternate.main"
                startIcon={<AddIcon color="alternate" />}
              >
                <Box onClick={handleOpen}>Select from existing evaluation</Box>
                <Box onClick={handleAddExternal}>Upload external evaluation via csv</Box>
                <Box onClick={handleUploadMatching}>Upload evaluation participants via csv</Box>
              </ACPopper>
            </Box>
          )}
        </Box>

        {/* Footer */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            width: { xs: '90%', md: '67%' },
            gap: 1,
          }}
        >
          {/* Appraisal Creation */}
          {!evalPage && (
            <>
              <AdxButton variant={'outlined'} onClick={() => navigate('/app/appraisal-cycle')}>
                Cancel
              </AdxButton>
              <AdxButton variant={'contained'} onClick={handleCreateAppraisal} sx={{ px: 7 }}>
                Next
              </AdxButton>
            </>
          )}

          {/* & Add Evaluations */}
          {evalPage && (
            <>
              <AdxButton variant={'outlined'} onClick={handleReturn}>
                Back
              </AdxButton>
              <AdxButton variant={'contained'} onClick={handleFinishAppraisal} sx={{ px: 7 }}>
                Create
              </AdxButton>
            </>
          )}
        </Box>
      </Box>

      {/* Modal to show Non Custom Matching evaluation list */}
      <ACNonCustomEvaluation
        isModalOpen={isModalOpen}
        handleClose={handleClose}
        handleNonCustomEval={handleNonCustomEval}
        nonCustomValue={nonCustomValue}
        handleAddNonCustomEval={handleAddNonCustomEval}
        allEvalData={allEvalData}
        nonCustomDisabled={nonCustomDisabled}
      />

      {/* Modal to upload External Evaluation */}
      {externalUpload && (
        <UploadExternalEvaluation
          appraisalId={appraisalData?.data?.id}
          setGetExternalData={setGetExternalData}
          completeUploadExternal={completeUploadExternal}
          setCompleteUploadExternal={setCompleteUploadExternal}
          setExternalCSVUpload={setExternalCSVUpload}
          getExternalData={getExternalData}
          refetchAppraisalData={refetchAppraisalData}
          setExternalLoading={setExternalLoading}
        />
      )}

      {/* Modal to show External Evaluation result */}
      {externalCSVUpload && (
        <ACExternalEvalTable
          getExternalData={getExternalData}
          externalCSVUpload={externalCSVUpload}
          setExternalCSVUpload={setExternalCSVUpload}
          setCompleteUploadExternal={setCompleteUploadExternal}
          setGetExternalData={setGetExternalData}
          externalLoading={externalLoading}
        />
      )}

      {/* Modal to show Custom Matching evaluation list */}
      <ACCustomEvaluation
        matchingUpload={matchingUpload}
        handleClose={handleClose}
        handleCustomEval={handleCustomEval}
        customValue={customValue}
        allEvalData={allEvalData}
        customDisabled={customDisabled}
      />

      {/* Modal to upload Matching */}
      {matchingCSVUpload && (
        <UploadMatchingCsv
          customMatchingId={customMatchingId}
          handleCloseMatchingCSV={handleCloseMatchingCSV}
          matchingCSVUpload={matchingCSVUpload}
          setShowMatchingTable={setShowMatchingTable}
          setGetMatchingData={setGetMatchingData}
          setCompleteUploadMatching={setCompleteUploadMatching}
          completeUploadMatching={completeUploadMatching}
          staffData={staffData}
          setUpload={setUpload}
          upload={upload}
          mutateConfirmUploadMatching={mutateConfirmUploadMatching}
          setMatchingLoading={setMatchingLoading}
        />
      )}

      {/* Modal to show Matching result */}
      {showMatchingTable && (
        <ACMatchingTable
          getMatchingData={getMatchingData}
          setShowMatchingTable={setShowMatchingTable}
          showMatchingTable={showMatchingTable}
          setCompleteUploadMatching={setCompleteUploadMatching}
          setStaffData={setStaffData}
          staffData={staffData}
          setUpload={setUpload}
          matchingLoading={matchingLoading}
        />
      )}
    </>
  )
}

export default AppraisalCycleConfig
